import { render, staticRenderFns } from "./Sell.vue?vue&type=template&id=845c8d98&scoped=true"
import script from "./Sell.vue?vue&type=script&lang=js"
export * from "./Sell.vue?vue&type=script&lang=js"
import style0 from "./Sell.vue?vue&type=style&index=0&id=845c8d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845c8d98",
  null
  
)

export default component.exports